import { createContext, ReactNode } from "react";

export const DrawerTypes = {
  FILTER: "filter",
  MORE_ACTIONS: "more_actions",
  TIME_SERIES_OPTIONS: "time_series_options",
  COMPARE_GROUPS: "compare_groups",
} as const;

export type DrawerType = (typeof DrawerTypes)[keyof typeof DrawerTypes];

export type DrawerConfig = {
  type: DrawerType;
  content: ReactNode;
  header?: string;
  headerLeftAdornment?: ReactNode;
  maxHeight?: string;
};

export type DrawerContextValue = {
  activeDrawer: DrawerType | null;
  registerDrawer: (config: DrawerConfig) => void;
  openDrawer: (type: DrawerType) => void;
  closeDrawer: () => void;
  isDrawerOpen: (type: DrawerType) => boolean;
  getActiveDrawerConfig: () => DrawerConfig | undefined;
};

export const MobileDrawerContext = createContext<DrawerContextValue | null>(
  null
);
